import React from "react";

function Footer() {
  return (
    <div className="bg-primary-dark py-10">
      <div className="max-w-screen-lg mx-auto">
        <div className="flex gap-4 justify-center">
          <div
            className="bg-white rounded-sm p-1 shadow-sm cursor-pointer"
            onClick={() => window.open("https://github.com/nonsense00027")}
          >
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
              className="h-10 w-10"
            />
          </div>

          <div
            className="bg-white rounded-sm p-1 shadow-sm cursor-pointer"
            onClick={() =>
              window.open(
                "https://www.linkedin.com/in/neil-fred-canete-5424671a7/"
              )
            }
          >
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linkedin/linkedin-original.svg"
              className="h-10 w-10"
            />
          </div>
        </div>
        <div className="text-center font-secondary text-white mt-2">
          <p>caneteneilfred@gmail.com</p>
          <p>+63905-875-4655</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
